import React, { useCallback } from "react";
import { EdgeProps, getBezierPath } from "reactflow";

const CustomEdge: React.FC<EdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  markerEnd,
  selected,
}) => {
  // Check if this is a decision edge (has _true or _false in the ID)
  const isDecisionEdge = id.includes("_true") || id.includes("_false");
  
  // Calculate the bezier path
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });

  // Respect provided style (stroke, strokeWidth, strokeDasharray). Fallbacks if missing.
  const fallbackStroke = isDecisionEdge ? "#b1b1b7" : "#b1b1b7";
  const fallbackWidth = isDecisionEdge ? 2 : 1;

  const effectiveStroke = (style.stroke as string) || fallbackStroke;

  return (
    <>
      {selected && (
        <path
          id={`${id}-highlight`}
          style={{
            stroke: effectiveStroke,
            strokeWidth: (style.strokeWidth as number || fallbackWidth) + 3,
            opacity: 0.6,
            pointerEvents: "none",
          }}
          className="react-flow__edge-path"
          d={edgePath}
        />
      )}
      <path
        id={id}
        style={{
          stroke: fallbackStroke,
          strokeWidth: fallbackWidth,
          // Allow edge-provided styles to override fallbacks (important for upstream styling)
          ...style,
        }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={markerEnd}
      />
      {/* Invisible wide interaction path to improve click/touch hit area */}
      <path
        d={edgePath}
        className="react-flow__edge-interaction"
        style={{
          fill: "none",
          stroke: "transparent",
          strokeWidth: Math.max((style.strokeWidth as number) || fallbackWidth, 12),
          cursor: "pointer",
        }}
      />
    </>
  );
};

export default CustomEdge; 